import { useState } from "react";
import { Link } from "react-router";

const CategoryCollapse = (props: any) => {

    let [activeH, setActiveH] = useState<any>();

    return (
        <>
            <div className="container">
                <div
                    className="collapse shadow show bg-white header-collapse w-75 position-absolute container"
                    id="collapse-menu"
                    onMouseLeave={props.closeMenu}
                >
                    <div className="container position-relative">
                        <div className="accordion bg-white position-relative">
                            <div className="row px-0">
                                <div className="col-md-3 px-0">
                                    <div className="col-place">
                                        {props.parentCategory?.map((category: any, index: number) => (
                                            <div className="col-lg-12" key={index}>
                                                <h2 onMouseOver={() => props.setCategoryId(category.id)} onMouseMove={() => setActiveH(index)} className="accordion-header bg-light border-0" id="headingOne">
                                                    <Link to={`/categories/${category.slug}`} className={activeH === index ? 'btn accordion-button bg-light border-0 fw-bold shadow-none text-site fw-bold' : 'btn accordion-button bg-light border-0 fw-bold shadow-none'} aria-expanded="true" aria-controls="collapseOne">
                                                        <div className="d-flex align-items-center w-100">
                                                            <img src={category.icon} style={{ width: '30px', height: '30px', objectFit: 'contain' }} alt="" />
                                                            <div className="ms-3">
                                                                {category.name}
                                                            </div>
                                                        </div>
                                                    </Link>
                                                </h2>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className="col-md-9">
                                    <div className="row gap-3 py-3">
                                        {props.childCategory?.map((item: any) => (
                                            <>
                                                {item.parent_id === props.categoryId ? (
                                                    <>
                                                        <div className="col-12 py-0">
                                                            <Link to={`/categories/${item.slug}`} className="text-decoration-none fw-bold text-dark">
                                                                {item.name}
                                                            </Link>
                                                        </div>
                                                    </>
                                                ) : null}
                                            </>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}

export default CategoryCollapse;